;(async () => {
  if (!customElements.get('size-guide-trigger')) {
    class SizeGuideTrigger extends HTMLElement {
      constructor() {
        super()

        this.sizeGuide = document.querySelector('size-guide')
        this.initialCollection = this.dataset.sizeGuideInitialCollection || null

        this.addEventListener('click', this.open.bind(this))
      }

      open() {
        if (!this.sizeGuide) {
          return
        }

        if (this.initialCollection) {
          this.sizeGuide.setInitialCollection(this.initialCollection)
        }

        this.sizeGuide.open()
      }
    }

    window.SizeGuideTrigger = SizeGuideTrigger
    customElements.define('size-guide-trigger', SizeGuideTrigger)
  }
})()
